import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DescargarDocumentoDto } from '../dto/descargar-documento.dto';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DocumentosService {
  private urlApi: string = environment.urlback;

  constructor(private readonly http: HttpClient) {}

  descargarDocumento(
    fileName: string,
    data: DescargarDocumentoDto
  ): Observable<any> {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = {
      headers: httpHeaders,
      responseType: 'blob' as 'json',
    };
    return this.http.post<any>(`${this.urlApi}/documentos`, data, options).pipe(
      tap((response) => {
        const blobData = new Blob([response], {
          type: 'application/pdf',
        });
        const data = window.URL.createObjectURL(blobData);
        const link = document.createElement('a');
        link.href = data;
        link.download = `${fileName}.pdf`;
        link.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      })
    );
  }
}
